<template>
  <div>
    <div class="home">

      <div class="comserver">

        <img src="../../assets/joinusimg/zkhz_banner_shouyijixujiaoyu.png" width="100%" alt="">

        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>引言</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-text">兽医继续教育学院致力于提高兽医素质，推动兽医行业发展。通过开展线上、线下课程，为养殖企业、动保企业、诊疗机构、高校、科研机构、一线兽医等提供兽医相关的理论、技能培训，为行业人才实现职业和事业的同步发展助力。线上课程，借助“互联网+”思维，利用中科名兽医APP、微信公众号平台，通过图文、音频、影像，在声光影形的科技教育生态中，实现交互式的学习，打造易学、有趣、智能、创新的兽医教育课程体系，让学员享受到学习的乐趣和成就感。线下课程，联系行业学会和协会，邀请全国知名院校、研究机构、国家单位、大型企业的专业人士及一线工作人员，联合举办形式多样的面授培训，进行现场授课、互动、答疑。</div>
            </div>
          </div>
        </div>
        
        <div class="box">
          <div class="title">
            <div class="shuTie"></div>
            <div class="titM">
              <div class="titMax"><b>兽医继续教育学院开发的课程包括</b> </div>
            </div>
          </div>
          <div class="info">
            <div class="company">
              <div class="company-title">职业兽医继续教育：</div>
              <div class="company-text">为在养殖企业、动物医院从事兽医诊疗服务工作的从业人员提供理论、实践、实操、兽医法规、兽医新技术等相关专业知识培训，提高其一线服务能力和水平。如您有需要请点击下方按钮联系我们。</div>
              <div class="company-title">兽医检验员职业教育：</div>
              <div class="company-text">利用中科基因实验室培训平台，为兽医实验室检验人员提供动物疫病检测新技术、新方法培训，定期开展实验室技能比武和能力验证，提升检验人员专业技能水平，指导生产实践。如您有需要请点击下方按钮联系我们。</div>
              <div class="company-title">畜牧兽医就业培训教育：</div>
              <div class="company-text">联合高校和职业院校，为在校即将毕业的畜牧兽医专业学生提供符合市场需求的实践技能培训，如检测技能培训、养殖生产管理培训、兽药疫苗生产培训；缩短毕业生就业实践周期，为企业输送优秀专业技能人才，实现毕业生职业和事业同步发展。如您有需要请点击下方按钮联系我们。</div>
              <div class="company-title">注册执业兽医师教育：</div>
              <div class="company-text">联合行业协会和学会，开展执业兽医师继续培训教育，提升中国执业兽医师专业理论和实践技能水平，为客户提供专业化的优质服务。如您有需要请点击下方按钮联系我们。</div>
              <div class="company-text">在兽医继续教育的平台上，您可以和我们共享兽医行业的信息，结识更多的行业精英，学习海量的专业知识，赢取更广的商业/工作机遇。</div>
              <div class="company-text">共享赋能，合作共赢，请加入我们，联系我们，与我们共同成长！</div>
            </div>
          </div>
          <div class="btnImg">
            <div class="btn1 urlA"  @click="joinUs('0401')">联系我们</div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'comserver',
  inject: ['reload'],
  data(){
    return{
      userid: '',
      link: '',
      id: '',
      ua: window.navigator.userAgent.toLowerCase(),
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      }
    }
  },
  created(){
    this.userid = this.$route.query.user_id
  },
  methods: {
    openApp() {
      window.location = 'http://t.cn/Aijv8II4'
    },
    goShareExperts() {
      if (this.browser.android) {
        ZKAPP.ShareExperts();
      }else {
        window.webkit.messageHandlers.ShareExperts.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    tel(val) {
      if (this.browser.android) {
        this.link = 'tel:'+val
      }else {
        this.link = 'javascript:;'
        window.webkit.messageHandlers.jsToOcTelePhone.postMessage({tel:val});
      }
    },
    joinUs(val) {
      this.$router.push({
        name: 'Addjoin',
        query:{
          type: val,
          userid: this.userid
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.comserver{
  position: relative;
}
.box{
  background: #fff;
  padding-top: 25px;
  border-bottom: 15px solid rgba(245, 245, 245, 1);
  .title{
    display: flex;
    .shuTie{
      width: 4px;
      height: 22px;
      background: #004ea2;
      margin-left: 20px;
    }
    .titM {
      .titMax{
        color: #004ea2;
        font-size: 20px;
        font-weight: 600;
        line-height: 22px;
        margin-left: 10px;
        b {
          font-weight: bold;
        }
      }
    }
  }
  .info {
    padding: 15px 30px;
    .company {
      .company-title{
        padding: 5px 0;
        font-weight:600;
        color:rgba(51, 51, 51, 1);
        margin-bottom: 4px;
        font-size: 14px;
        text-align: center;
      }
      .company-text {
        line-height: 20px;
        font-size: 14px;
        color:rgba(51, 51, 51, 1);
        text-align: left;
      }
    }
  }
  .btnImg{
    width:100%;
    height: 60px;
    padding-bottom: 10px;
  }
}
.box1 {
  background: #fff;
  padding-top: 25px;
  margin-bottom: 15px;
  font-size: 0;
  .phone {
    text-align: center;
    .phoneInfo {
      display: flex;
      .shuTie {
        width: 4px;
        height: 22px;
        background: #004ea2;
        margin-left: 20px;
      }
      .phoneTit {
        color: #004ea2;
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        margin-left: 10px;
        b {
          font-weight: bold;
        }
      }
    }
  }
  .btn {
    padding-bottom: 30px;
  }
}

.btn1 {
  width: 184px;
  margin: 30px auto 0px;
  display: block;
  text-align: center;
  background: -webkit-linear-gradient(left, #0097e0 , #004ea2); /* Safari 5.1 - 6.0 */
  // background: -o-linear-gradient(left, #0097e0, #004ea2); /* Opera 11.1 - 12.0 */
  // background: -moz-linear-gradient(left, #0097e0, #004ea2); /* Firefox 3.6 - 15 */
  // background: linear-gradient(left,#0097e0, #004ea2);
  padding: 15px 0;
  border-radius: 50px;
  font-size: 14px;
  color:#fff;
}
</style>
